namespace TabAurous.Common {
    export interface CancelOrderForm {
        ReasonId: Serenity.LookupEditor;
        Remark: Serenity.TextAreaEditor;
    }

    export class CancelOrderForm extends Serenity.PrefixedContext {
        static formKey = 'Common.CancelOrder';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CancelOrderForm.init)  {
                CancelOrderForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(CancelOrderForm, [
                    'ReasonId', w0,
                    'Remark', w1
                ]);
            }
        }
    }
}
